// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"VideoList_tableWrapper__1kH2k","empty":"VideoList_empty__2nchD","promptWrapper":"VideoList_promptWrapper__Lr2oc","bp3-tabs":"VideoList_bp3-tabs__29KtI"};